import type { HeroStatKey } from '@somnhold/content';
import { gearMods, heroStats, levelStat, rankAt, type PlayerState } from '@somnhold/sim';
import { getLang, t } from '../i18n.ts';

const pct = (bp: number): string => (bp / 100).toLocaleString(getLang() === 'es' ? 'es-AR' : 'en-US', { maximumFractionDigits: 1 });

/** The shares of the level shown as percents (health and damage go into the plain numbers). */
const PCT_STATS: HeroStatKey[] = ['armor', 'cooldown', 'attackSpeed', 'range', 'healing'];

/**
 * What a hero gains going from one level to another, with the same gear: health and attack as
 * numbers, the rest as percents, and the skills' rank when it changes. Shares under 0.05 % are left out.
 */
export const levelGains = (p: PlayerState, from: number, to: number): string[] => {
  const hero = p.hero;
  const cls = hero.heroClass;
  const at = (level: number) => heroStats({ pid: p.id, name: '', cls, level, control: 'live', powerBp: 10000, post: 0, gear: gearMods(hero) });
  const a = at(from);
  const b = at(to);
  const out: string[] = [];
  if (b.maxHp > a.maxHp) out.push(t('levelGain.hp', { v: b.maxHp - a.maxHp }));
  if (b.attack > a.attack) out.push(t('levelGain.attack', { v: b.attack - a.attack }));
  for (const k of PCT_STATS) {
    const d = levelStat(cls, to, k) - levelStat(cls, from, k);
    if (d >= 5) out.push(t(`stat.${k}`, { v: pct(d) }));
  }
  if (rankAt(to) > rankAt(from)) out.push(t('levelGain.rank', { n: ['I', 'II', 'III'][rankAt(to) - 1] as string }));
  return out;
};
